/* eslint-disable global-require */
module.exports = [...require('./Prices/i18n'), 'estimate.show.m12', 'estimate.show.m13', 'indexes._second_chart.m6'];
